import { dataLog } from '../data/data_audit_log';
import AuthUtils from '../auth/auth_utils';
 
const AuditFunctions = {

    LogUserAction(action, type, value) {
        const userId = AuthUtils.ExtractTokenUser();
        dataLog.saveLogItem({userId: userId, action: action, type: type, value: value});
    }

}

export default AuditFunctions;